import { loginOut } from '@/services/auth';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { history, useModel } from '@umijs/max';
import { Dropdown, Spin } from 'antd';
import React, { useCallback } from 'react';
import styles from './index.less';

export const AvatarDropdown: React.FC = () => {
  const { initialState } = useModel('@@initialState');

  const onMenuClick = useCallback(({ key }: { key: string }) => {
    if (key === 'logout') {
      loginOut();
      return;
    }
    history.push(key);
  }, []);

  const loading = (
    <span className={`${styles.action} ${styles.account}`}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  const { currentUser } = initialState;

  if (!currentUser || !currentUser.email) {
    return loading;
  }

  return (
    <Dropdown
      menu={{
        items: [
          {
            icon: <UserOutlined />,
            label: '个人中心',
            key: '/profile/index',
          },
          {
            icon: <LogoutOutlined />,
            label: '退出登录',
            key: 'logout',
          },
        ],
        className: styles.menu,
        onClick: onMenuClick,
      }}
    >
      <span className={`${styles.action} ${styles.account}`}>
        <span className={`${styles.name}`}>{initialState?.currentUser?.email}</span>
      </span>
    </Dropdown>
  );
};
